import './App.css';

function App() {
  return (
    <main className="coming-soon" id="top">
      <div className="page-frame">
        <header className="masthead">
          <div className="wordmark">
            <span className="wordmark-symbol" aria-hidden="true">B</span>
            <span>BONDEHORSES</span>
          </div>
          <p className="masthead-note">Et nyt kapitel tager form</p>
        </header>

        <section className="hero" aria-labelledby="hero-title">
          <div className="hero-copy">
            <p className="eyebrow"><span aria-hidden="true" /> Bondehorses</p>
            <h1 id="hero-title">kommer snart</h1>
            <div className="opening-note">
              <span className="opening-indicator" aria-hidden="true" />
              Åbner snart
            </div>
          </div>

        </section>

        <footer className="page-footer">
          <span>Skabt med omtanke</span>
          <span>© 2026 Bondehorses</span>
        </footer>
      </div>
    </main>
  );
}

export default App;
